<!--
2023-08-17 YTW Vip体系
-->
<template>
  <div class="main-content">
    <TopBack :title="$t('lang.common.freeCash')" :handelBack="goBack" />
    <div class="nav-bar">
      <div class="nav" @click="goto('BetActivityRegularly')">
        <span>{{ $t('lang.betActivityRegularly.cashbackRewards') }}</span>
        <div class="redPoint" v-show="$store.state.BetRewardHot===true"/>
      </div>
      <div class="act">
        <span>{{ $t('lang.cashback.route') }}</span>
        <div class="redPoint" v-show="$store.state.CashBackHot===true"/>
      </div>
    </div>
    <div class="last-boxes-container">
      <div class="bannerBox">
        <div class="banner-bottom">
          <img
            alt="CashbackBanner"
            class="banner-image"
            src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/l7jajbpuq7maond6xka765aqm9ub5x21Cashback_PGE.png"
          >
          <div class="banner-text">{{$t('lang.cashback.title')}}</div>
        </div>
      </div>
      <div class="card" :style="{backgroundImage:'url('+require('../../assets/images/vip/boxback.png')+')'}">
        <div class="card-title">
          <span>{{$t('lang.cashback.tr1')}}</span>
          <span>{{$t('lang.cashback.tr2')}}</span>
        </div>
        <div class="card-content">
          <span><span style="color: #FFFFFF">{{ $t('lang.account.currencyType') }} </span>{{
              cash.AvailableReward
            }}</span>
          <span><span style="color: #FFFFFF">{{
              $t('lang.account.currencyType')
            }} </span>{{
              cash.InProgressReward
            }}</span>
        </div>
      </div>
      <div class="card-btn" @click="collect">{{ $t('lang.cashback.cardBtn') }}</div>
      <div class="card-btn1" @click="rules">{{ $t('lang.cashback.cardBtn1') }}</div>
      <div class="gameBox">
        <div class="game-top">
          <div class="title"><span style="font-weight: 700;font-size: 19px">
            <span style="color: #FFC412">▋</span>{{ $t('lang.VIP.hot') }}</span>
          </div>
          <div class="seeAll"></div>
        </div>
        <div class="game-bottom">
          <div class="game"
               v-for="(item, index) in gameList"
               :key="'recommend'+index"
          >
            <div class="imgContainer">
              <div class="game-image-wrapper" :style="{backgroundImage:'url('+item.ThumbnailUrl+')'}"
                   @click="fetchGame(item)">
              </div>
            </div>
            <p>{{ item.GameNameEn }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" v-if="winShow">
      <div class="content">
        <div class="claimedTitle" v-if="collectOK">
          {{ $t('lang.betActivityRegularly.Success') }}
        </div>
        <div class="claimResult" v-if="collectOK">
          {{ $t('lang.betActivityRegularly.claimResultSuccess') }}
        </div>
        <div class="claimResult" v-else>
          {{ $t('lang.betActivityRegularly.claimResultFailed') }}
        </div>
<!--        <div class="claimResultNotReached" v-if="!collectOK">
          {{ $t('lang.betActivityRegularly.claimResultNotReached') }}
        </div>-->
        <button @click="onPlay">
          {{ $t('lang.betActivityRegularly.playNow') }}
        </button>
        <div class="cancel" @click="closeModal">
          {{ $t('lang.betActivityRegularly.cancel') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
import {Toast} from 'mint-ui'
import config from '../../../static/config/config'
import back from '@/assets/images/common/back.svg'
import TopBack from '@/components/TopBack/index'
import {fetchBalance} from '@/utils'

export default {
  name: 'CashBack',
  computed: {},
  data () {
    return {
      backRoute: 'Home',
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      iFrameSrc: 'https://history.jlfafafa3.com/action/20230726K/slot',
      winShow: false,
      gameList: [],
      back,
      fetchBalance,
      cash: {},
      collectOK: false
    }
  },
  watch: {
  },
  components: {
    TopBack
  },
  mounted () {
    this.fetchData()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name && (from.name === 'Home' || from.name === 'Promotion' || from.name === 'Vip' || from.name === 'SportsBetting')) {
        vm.$store.commit('setFreeCashBackRoute', from.name)
      }
    })
  },
  methods: {
    fetchData () {
      if (!this.userInfo || !this.userInfo.UserId) {
        this.$router.push('/Login')
        // this.$store.commit('setLoginPopShow', true)
        return
      }
      const url = '/innovation/cashback/getdata'
      const data = {UserId: this.userInfo.UserId}
      request('post', url, data).then(res => {
        this.cash.AvailableReward = res.AvailableReward
        this.cash.InProgressReward = res.InProgressReward
        this.gameList = res.VipGames
        console.log(res)
      }).catch(() => {
        Toast(Toast(this.$t('lang.home.gameMaintenancePrompt')))
      })
    },
    collect () {
      if (!this.userInfo || !this.userInfo.UserId) {
        this.$router.push('/Login')
        // this.$store.commit('setLoginPopShow', true)
        return
      }
      const url = '/innovation/cashback/collect'
      const data = {UserId: this.userInfo.UserId}
      request('post', url, data, true).then(res => {
        this.$store.commit('setCashBackHot', false)
        if (res > 0) {
          this.collectOK = true
          this.fetchBalance()
          this.fetchData()
        } else {
          this.collectOK = false
        }
        this.winShow = true
      }).catch(() => {
        Toast(Toast(this.$t('lang.home.gameMaintenancePrompt')))
      })
    },
    rules () {
      this.$router.push('/CashBackRules')
    },
    fetchGame (game) { // 原来的fetchGame
      if (this.userInfo) {
        if (this.$store.state.banUserId.includes(this.userInfo.UserId)) {
          Toast(this.$t('lang.home.gameMaintenancePrompt'))
          return
        }
        const url = '/innovation/game/getgameurl'
        const data = {
          userId: this.userInfo.UserId || '',
          gameCode: game.GameCode,
          gameProviderId: game.GameProviderId,
          deviceWidth: document.body.clientWidth,
          lang: localStorage.getItem('locale'),
          internation: this.$store.state.internation,
          campaignId: localStorage.getItem('cid'),
          localVersion: config.version,
          localApkVersion: localStorage.getItem('apkV') ? localStorage.getItem('apkV') : '1.0.0'
        }
        request('post', url, data, true).then(res => {
          if (res.Url) {
            const gameInfo = {
              gameUrl: res.Url,
              gameImg: game.ThumbnailUrl,
              gameName: game.GameNameEn
            }
            this.$store.commit('setShowGame', true)
            this.$store.commit('setGameInfo', gameInfo)
          } else {
            Toast(this.$t('lang.home.gameMaintenancePrompt'))
          }
        }).catch(() => {
          Toast(Toast(this.$t('lang.home.gameMaintenancePrompt')))
        })
      } else {
        this.$router.push('/Login')
      }
    },
    onPlay () {
      this.$router.push('/Home')
    },
    goto (path) {
      this.$router.push('/' + path)
    },
    close () {
      this.fetchData()
      this.showGame = false
    },
    goBack () {
      this.$router.push('/' + this.$store.state.freeCashBackRoute)
    },
    closeModal () {
      this.winShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  background-color: #150F0F;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 56px 0 100px 0;
  overflow-x: hidden;

  .top {
    display: flex;
    align-items: center;
    width: 100vw;
    margin-top: 10px;
    margin-bottom: 7px;
    padding-left: 16px;

    .title {
      margin-left: 15px;
      font-size: 18px;
      color: #F6D9AA;
      font-weight: bold;
    }
  }

  .nav-bar {
    margin: 3vw auto;
    width: 82vw;
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
      width: 40.555vw;
      text-align: center;
      font-size: 5vw;
      font-weight: 400;
      height: 7.13vw;
    }

    .nav {
      position: relative;
      color: #5C5C5C;
      border-bottom: 0.8vw solid transparent;
    }

    .act {
      position: relative;
      color: #F6D9AA;
      border-bottom: 0.8vw solid #F6D9AA;
    }

    .redPoint {
      position: absolute;
      top: 0;
      right: 0;
      width: 2.3vw;
      height: 2.3vw;
      border-radius: 50%;
      background: red;
    }
  }

  .last-boxes-container {
    width: 100%;
    background-color: #0D0D0D;

    .bannerBox {
      margin: 1vw auto 0 auto;
      width: 100vw;

      .banner-image {
        height: 44.4445vw;
      }

      .banner-text {
        margin-top: 1vw;
        padding-left: 4.167vw;
        font-size: 5.278vw;
        font-weight: 400;
        text-align: left;
        color: #D9D8D8;
      }
    }

    .card {
      margin: 3vw auto;
      width: 95.555vw;
      height: 24.722vw;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      .card-title {
        display: flex;
        justify-content: space-between;
        font-size: 5.277vw;
        font-weight: 400;
        letter-spacing: -0.04em;
        text-align: left;
        color: #7E7E7E;

        span {
          width: 46.667vw;
          text-align: center;
          line-height: 12.5vw;
          text-shadow: 3px 3px 2px #000000;
        }
      }

      .card-content {
        display: flex;
        justify-content: space-between;
        font-size: 7.5vw;
        font-weight: 700;
        letter-spacing: -0.06em;
        text-align: left;

        span {
          width: 46.667vw;
          text-align: center;
          line-height: 13vw;
          color: #FFC810;
        }
      }
    }

    .card-btn {
      background: #F6D9AA;
      width: 90.555vw;
      height: 12.777vw;
      border-radius: 2.222vw;
      margin: 4vw auto 2vw auto;
      font-size: 6.111vw;
      font-weight: 400;
      line-height: 12.777vw;
      text-align: center;
      color: #000D2E;
    }

    /*    .card-btn {
          background: #0369B9;
          width: 90.555vw;
          height: 12.777vw;
          border-radius: 2.222vw;
          margin: 4vw auto 2vw auto;
          font-size: 6.944vw;
          font-weight: 400;
          line-height: 12.777vw;
          text-align: center;
          color: #FFFFFF;
        }*/

    .card-btn1 {
      width: 90.555vw;
      border-radius: 2.222vw;
      margin: 3vw auto 0.5vw auto;
      font-size: 5.277vw;
      font-weight: 400;
      text-align: center;
      color: #373737;
      text-decoration: underline;
    }

    .gameBox {
      margin: 1vh auto 0 auto;
      width: 100vw;
      border-radius: 20px 20px 0 0;
      background-color: #1A1A1A;

      .game-top {
        margin: 2vh auto 0.5vh auto;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        min-height: max-content;

        .title {
          margin-top: 1.5vh;
          color: #FFFFFF;
          width: 100%;
          text-align: left;
          padding-left: 7.22vw;
          font-size: 22px;
          font-weight: 700;
          line-height: 31px;
          letter-spacing: 0em;
        }
      }

      .game-bottom {
        height: max-content;
        padding-top: 1vh;
        overflow: auto;

        .game {
          width: 45%;
          margin: 0 1% 20px 3%;
          float: left;

          .imgContainer {
            position: relative;
            height: 0;
            padding-bottom: 60%;
            overflow: hidden;
            border-radius: 6px;

            .game-image-wrapper {
              background-position: center;
              width: 100%;
              height: 26.4vw;
              background-repeat: no-repeat;
              background-size: cover;
              position: relative;
            }
          }

          p {
            text-align: center;
            width: 100%;
            color: #9F9F9F;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 18px;
            font-weight: 400;
            line-height: 25px;
            margin-top: 5px;
          }
        }

        .last {
          margin-right: 0;
        }

        .showMore {
          text-align: center;

          img {
            width: 10px;
          }
        }

        /deep/ .mint-loadmore-content {
          position: relative;

          &:after {
            content: "020";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
          }

          .mint-loadmore-bottom {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            height: 20px;
            line-height: 20px;
            margin-bottom: -20px;
          }
        }
      }
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
    @media screen and (max-height: 750px) {
      .content {
        width: 88vw;
        height: max-content;
        padding: 24px;
        background: #1c1c1e;
        border: #737373 2px solid;
        border-radius: 15px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;

        .claimedTitle {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          color: #ffffff;
          line-height: 32px;
        }

        .claimResult {
          width: 100%;
          margin: 15px 0 28px 0;
          font-size: 18px;
          font-weight: 400;
          color: #ffffff;
          line-height: 22px;
        }

        .claimResultNotReached {
          width: 100%;
          margin: 20px 10px;
          font-size: 14px;
          font-weight: 400;
          color: #cc1313;
          line-height: 20px;
        }

        button {
          height: 44px;
          width: 100%;
          background-color: #f1dab0;
          border: none;
          border-radius: 8px;
          font-size: 20px;
          font-weight: 700;
          color: #220303;
        }

        .cancel {
          width: 100%;
          margin-top: 22px;
          text-align: center;
          font-size: 20px;
          font-weight: 400;
          color: #696969;
        }
      }
    }
    @media screen and (min-height: 751px) {
      .content {
        width: 88vw;
        height: max-content;
        padding: 24px;
        background: #1c1c1e;
        border: #737373 2px solid;
        border-radius: 15px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;

        .claimedTitle {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          color: #ffffff;
          line-height: 32px;
        }

        .claimResult {
          width: 100%;
          margin: 15px 0 28px 0;
          font-size: 18px;
          font-weight: 400;
          color: #ffffff;
          line-height: 22px;
        }

        .claimResultNotReached {
          width: 100%;
          margin: 20px 10px;
          font-size: 14px;
          font-weight: 400;
          color: #cc1313;
          line-height: 20px;
        }

        button {
          height: 48px;
          width: 100%;
          background-color: #f1dab0;
          border: none;
          border-radius: 8px;
          font-size: 22px;
          font-weight: 700;
          color: #220303;
        }

        .cancel {
          width: 100%;
          margin-top: 22px;
          text-align: center;
          font-size: 20px;
          font-weight: 400;
          color: #696969;
        }
      }
    }
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

</style>



// WEBPACK FOOTER //
// src/pages/CashBack/index.vue